import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import OfficeSupplyCategory from '@/types/table/officeSupplyCategory';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface OfficeSupplyCategoryData extends OfficeSupplyCategory {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class OfficeSupplyCategoryController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<OfficeSupplyCategoryData>>(API_CONTEXT + '/office/officeSupplyCategory/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficeSupplyCategoryData>(API_CONTEXT + '/office/officeSupplyCategory/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/office/officeSupplyCategory/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/office/officeSupplyCategory/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/office/officeSupplyCategory/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyCategory/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyCategory/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyCategory/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyCategory/deleteBatch', params, httpOptions);
  }
}
